/**
 * Shared weight-descriptor validation and display utilities.
 *
 * Used by GeneralSettings.js (department weights, forced-weight variants) and
 * the new WeightOptionsPage (DepartmentVariantWeightsSection, future per-item
 * overrides UI).  Keep this module pure (no React, no side-effects).
 */

/**
 * Returns true if `value` is a valid weight descriptor string understood by
 * the GlobePOS import pipeline.
 *
 * Valid examples: "250g", "1kg", "1.5 lb", "500 grams", "2 kilograms"
 * Invalid: "", "abc", "g", "10", null, 42
 *
 * @param {*} value - The candidate value to test.
 * @returns {boolean}
 */
export function isValidWeightDescriptor(value) {
  if (typeof value !== "string") return false;
  return /^\d+(\.\d+)?\s*(kg|kilogram|kilograms|g|gram|grams|lb|lbs|pound|pounds)$/i.test(
    value.trim(),
  );
}
